module.exports = require("./az-Arab");